export default __webpack_public_path__ + "static/media/iconosbtn_barcode.12b908ed.png";